import { ADD_FILE, UPDATE_FILE, UPDATE_IMPORT } from '../actions/import_object';

export default function(state = {}, action) {
  switch (action.type) {
  case ADD_FILE: {
    const id = action.file.id;
    const files = { ...state.files };

    files[id] = action.file;
    return {
      ...state,
      files
    };
  }
  case UPDATE_FILE: {
    const files = { ...state.files };
    files[action.file.id] = action.file;
    return {
      ...state,
      files
    };
  }
  case UPDATE_IMPORT: {
    return {
      ...action.importObject
    };
  }
  default:
    return { ...state };
  }
}